import { asPlaybookId } from "@repo/app-types/entities/playbook";
import { asTeammateId } from "@repo/app-types/entities/teammate";
import type { FC } from "react";
import { useParams } from "react-router";
import { NavigationSlideoverContainer } from "../../hooks/useModalNavigation.js";
import { CriterionDialog } from "./criterionDialog.js";

export const TrainingTeammatePagePlaybookCriterion: FC = () => {
  const {
    playbookId: playbookIdParam,
    teammateId: teammateIdParam,
    criterionId,
  } = useParams();
  if (!playbookIdParam || !teammateIdParam || !criterionId) {
    throw new Error("Missing params.");
  }

  const playbookId = asPlaybookId(playbookIdParam);
  const teammateId = asTeammateId(teammateIdParam);

  return (
    <>
      <CriterionDialog
        playbookId={playbookId}
        teammateId={teammateId}
        criterionId={criterionId}
      />
      <NavigationSlideoverContainer />
    </>
  );
};
